import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store/store'
import router from './router'
import Vuelidate from "vuelidate/src";
import GSignInButton from 'vue-google-signin-button'
import {VueReCaptcha} from "vue-recaptcha-v3";
import { RECAPTCHA_V3_KEY } from '../config/app';

Vue.config.productionTip = false;

Vue.use(GSignInButton);
Vue.use(VueReCaptcha, {
  siteKey: RECAPTCHA_V3_KEY, loaderOptions: {
    autoHideBadge: true
  }
})

new Vue({
  vuetify,
  store,
  router,
  Vuelidate,
  render: h => h(App)
}).$mount('#app');
